import type * as hast from 'hast';

import { getBooleanAttribute } from './attributes';

export const isElement = (node: hast.Node): node is hast.Element => node.type === 'element';

export const isLinkElement = (node: hast.Node): node is hast.Element =>
    isElement(node) && node.tagName === 'a';

export const isEmptyFootnoteLinkElement = (node: hast.Node): node is hast.Element =>
    isLinkElement(node) &&
    getBooleanAttribute(node.properties, 'dataFootnoteRef') &&
    node.children.length === 0;

export const isFootnoteBackrefElement = (node: hast.Node): boolean =>
    isLinkElement(node) && getBooleanAttribute(node.properties, 'dataFootnoteBackref');

export const isEmpty = (node: hast.Node): boolean =>
    !isElement(node) || !node.children || node.children.length === 0;
